// extracted by mini-css-extract-plugin
export default {"tab":"Tabs_tab__GYIS5","active":"Tabs_active__04Rrj"};